import * as React from 'react';

import * as main from '../../../styles/main.module.scss';
import * as pill from './pill.module.scss';

export const Pill = () => {
  return (
    <section className={pill.pill}>
      <div className={"container"}>
        <div className={pill.pill__container}>
          <h2 className={main.mainTitle}>Это не таблетка</h2>
          <ul className={pill.pill__ourThemes}>
            <li className={pill.pill__ourThemesItem}>
              <p><strong>Мы не будем рассказывать про «волшебную таблетку» и «позитивное мышление»</strong></p>
              <p>Мы ждём на вебинаре осознанных людей, готовых услышать правду. Понять, что много сил и времени уже потрачено зря, но есть способы изменить ситуацию.</p>
            </li>
            <li className={pill.pill__ourThemesItem}>
              <p><strong>Мы будем говорить о сложных вещах, но очень простыми словами</strong></p>
              <p>Мы верим в вас и знаем, что вы способны на большее. Мы знаем, как раскрыть ваш потенциал. </p>
            </li>
            <li className={pill.pill__ourThemesItem}>
              <p><strong>Мы разберём предыдущий опыт и типовые ошибки</strong></p>
              <p>Расскажем, как можно сделать иначе. И главное:  мы поделимся опытом. Вы всё сможете. Да, прямо на вебинаре вы увидите, что ваши способности и потенциал превосходят ваши ожидания.
              </p>
            </li>
            <li className={pill.pill__ourThemesItem}>

            </li>
          </ul>
          <a href={"#widget"} data-target={"#widget"} className={`${main.mainBtn} ${pill.pill__btn}`}>Зарегистрироваться</a>
        </div>
      </div>
    </section>
  );
};
